import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import ConversationList from "./sub/ConversationList/index";

import { UncontrolledTooltip, Tooltip } from "reactstrap";

import DateTime from "luxon/src/datetime.js";

//i18n
import { withTranslation } from "react-i18next";

import "./ConversationTableBody.scss";
import { Duration } from "luxon";
import { convertSlaTime } from "../../../../../../../../../../Libs/CustomMethods/customMethods";
import { useCallback } from "react";

import agentIcon from "../../../../../../../../../../assets/images/agents.svg";

const agentInfo = {
  icon: agentIcon,
  alt: "ai agent icon",
  description: "Artificial Intelligence Conversational Agent",
  visible: true,
};

//Here the control for how many cards'll be displayed and the threating of the agent's require
const ConversationTableBody = ({
  t,
  conversationDownload,
  conversationTransfer,
  conversationClose,
  conversationSpy,
  payloadData,
  loadingData,
  loadingDownload,
  conversationsChecked: {
    conversationsCheckedArray,
    setConversationsCheckedArray,
  },
  handleSort,
  orderBy,
  ...props
}) => {
  const { data } = useSelector((state) => state.Login);
  const [tooltipCopy, setTooltipCopy] = useState(false);
  const [dateNow, setDateNow] = useState(Date.now());
  const timeOutControl = useRef(null);
  const isNotDownload = ["real_automation", "telefone"];

  const iconsObject = {
    telefone: {
      name: "telefone",
      icon: "phone",
    },
    real_automation: {
      name: "Ticket",
      icon: "ticket",
    },
  };

  useEffect(() => {
    if (tooltipCopy) {
      setTimeout(() => {
        setTooltipCopy(false);
      }, 1000);
    }
  }, [tooltipCopy]);

  useEffect(() => {
    timeOutControl.current = setTimeout(() => {
      setDateNow(Date.now());
    }, 1000);

    return () => {
      clearTimeout(timeOutControl.current);
    };
  }, [dateNow]);

  const renderTimeFormatQueue = useCallback(
    (time, id = "") => {
      if (!time)
        return (
          <>
            {`${t("queue")}`}
            <i
              className="bx bx-refresh font-size-14 ml-1"
              id={`tooltip-sla-time-${id}`}
            />
            <UncontrolledTooltip
              className="tooltip-actions"
              placement="auto"
              target={`tooltip-sla-time-${id}`}
            >
              {t("Queue in Process")}
            </UncontrolledTooltip>
          </>
        );

      const start = new Date(time).getTime();
      const secs = parseInt((dateNow - start) / 1000) || 0;
      const timeF = convertSlaTime(secs, {
        withSummary: true,
      });

      return (
        <>
          <p
            style={{ fontSize: "1em" }}
            className={`${secs >= 20 ? "text-warning" : ""}`}
            id={`tooltip-sla-time-${id}`}
          >
            {`${t("queue")}  ${timeF?.summary}`}
          </p>
          <UncontrolledTooltip
            className="tooltip-actions"
            placement="auto"
            target={`tooltip-sla-time-${id}`}
          >
            {`${timeF?.full}`}
          </UncontrolledTooltip>
        </>
      );
    },
    [t, dateNow]
  );

  const renderTimeFormat = useCallback((item, isNegative) => {
    if (!item?.sla_time) return <></>;

    const timeSla = convertSlaTime(Number(item?.sla_time), {
      withSummary: true,
    });

    return (
      <>
        <p className="ml-2" id={`tooltip-sla-time-${item?.id}`}>
          {`${isNegative ? "-" : ""}${timeSla?.summary}`}
        </p>
        <UncontrolledTooltip
          className="tooltip-actions"
          placement="right"
          target={`tooltip-sla-time-${item?.id}`}
        >
          {`${isNegative ? "-" : ""}${timeSla?.full}`}
        </UncontrolledTooltip>
      </>
    );
  }, []);

  const renderConversationStatus = useCallback(
    (item) => {
      switch (item?.status) {
        case "pre-chat":
        case "pos-chat":
          return (
            <p className="font-weight-bold text-uppercase text-nowrap text-info">
              {t(item.status)}
            </p>
          );
        case "expired_sla":
          return (
            <div className="d-flex font-weight-bold text-uppercase text-nowrap text-danger">
              {t(item.status)}
              {renderTimeFormat(item, true)}
            </div>
          );
        case "active":
          return (
            <div className="d-flex font-weight-bold text-uppercase text-nowrap text-success">
              {t(item.status)}
              {renderTimeFormat(item, false)}
            </div>
          );
        case "inactive":
        case "new":
          return (
            <p className="font-weight-bold text-uppercase text-nowrap text-inactive">
              {t(item.status)}
            </p>
          );
        case "queue":
          return (
            <p className="font-weight-bold text-uppercase text-nowrap text-primary">
              {renderTimeFormatQueue(item?.queue_time, item?.id)}
            </p>
          );
        default:
          return (
            <p className="font-weight-bold text-uppercase text-nowrap text-closed">
              {t(item.status)}
            </p>
          );
      }
    },
    [renderTimeFormatQueue, t, renderTimeFormat]
  );

  let payload =
    payloadData?.length > 0
      ? payloadData.map((item, key) => ({
          ...item,
          statusName: item.status,
          select: (
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input"
                checked={conversationsCheckedArray?.list?.[key] ?? false}
                readOnly
              />
              <label
                className="custom-control-label pointer"
                onClick={() => {
                  let aux = conversationsCheckedArray.list;
                  let all = conversationsCheckedArray.all;
                  if (conversationsCheckedArray.list[key]) {
                    aux[key] = false;
                    all = false;
                  } else {
                    aux[key] = item;
                  }
                  setConversationsCheckedArray((prev) => ({
                    ...prev,
                    all,
                    list: aux,
                  }));
                }}
              ></label>
            </div>
          ),
          action: (
            <div className="table-actions-buttons">
              <i
                id={`tooltipdownload${key}`}
                className={`font-size-14  ${
                  loadingDownload?.[item.id]
                    ? "mdi mdi-loading sppiner-download-pdf"
                    : "mdi mdi-download action-mdb-icon"
                }${
                  !isNotDownload.includes(item.channel_name) &&
                  Array.isArray(data?.permissions?.conversation_download) &&
                  data?.permissions?.conversation_download.includes("get") &&
                  Array.isArray(data?.permissions?.conversation_download) &&
                  data?.permissions?.conversation_download.includes("get")
                    ? " text-muted"
                    : "-disabled"
                } `}
                onClick={() =>
                  !loadingDownload?.[item.id] &&
                  Array.isArray(data?.permissions?.conversation_download) &&
                  data?.permissions?.conversation_download.includes("get") &&
                  Array.isArray(data?.permissions?.conversation_download) &&
                  data?.permissions?.conversation_download.includes("get") &&
                  !isNotDownload.includes(item.channel_name) &&
                  conversationDownload(item)
                }
              />
              <i
                id={`tooltiptransfer${key}`}
                className={`font-size-14 mdi mdi-arrow-right action-mdb-icon${
                  item.status !== "closed" &&
                  item.status !== "pos-chat" &&
                  Array.isArray(data?.permissions?.conversation) &&
                  data?.permissions?.conversation.includes("transfer") &&
                  Array.isArray(data?.permissions?.conversation) &&
                  data?.permissions?.conversation.includes("transfer")
                    ? " text-muted"
                    : "-disabled"
                } px-2`}
                onClick={() => {
                  item.status !== "closed" &&
                    item.status !== "pos-chat" &&
                    Array.isArray(data?.permissions?.conversation) &&
                    data?.permissions?.conversation.includes("transfer");
                  Array.isArray(data?.permissions?.conversation) &&
                    data?.permissions?.conversation.includes("transfer");
                  conversationTransfer(item);
                }}
              />
              <i
                id={`tooltipclose${key}`}
                className={`font-size-14 mdi mdi-window-close action-mdb-icon${
                  item.status !== "closed" &&
                  item.status !== "pos-chat" &&
                  Array.isArray(data?.permissions?.conversation) &&
                  data?.permissions?.conversation.includes("put") &&
                  Array.isArray(data?.permissions?.conversation) &&
                  data?.permissions?.conversation.includes("put") &&
                  item.channel_name !== "real_automation"
                    ? " text-muted"
                    : "-disabled"
                } pr-2`}
                onClick={() => {
                  item.status !== "closed" &&
                    item.status !== "pos-chat" &&
                    Array.isArray(data?.permissions?.conversation) &&
                    data?.permissions?.conversation.includes("put") &&
                    Array.isArray(data?.permissions?.conversation) &&
                    data?.permissions?.conversation.includes("put") &&
                    item.channel_name !== "real_automation" &&
                    conversationClose(item);
                }}
              />
              <i
                id={`tooltipspy${key}`}
                className={`font-size-14 mdi mdi-eye action-mdb-icon${
                  item.user_id !== data.user.id || item.status === "closed"
                    ? " text-muted"
                    : "-disabled"
                }`}
                onClick={() =>
                  (item.user_id !== data.user.id || item.status === "closed") &&
                  conversationSpy(item)
                }
              />
              <UncontrolledTooltip
                className="tooltip-actions"
                placement="auto"
                target={`tooltipdownload${key}`}
              >
                {t("Download chat")}
              </UncontrolledTooltip>
              <UncontrolledTooltip
                className="tooltip-actions"
                placement="auto"
                target={`tooltiptransfer${key}`}
              >
                {t("Transfer")}
              </UncontrolledTooltip>
              <UncontrolledTooltip
                className="tooltip-actions"
                placement="auto"
                target={`tooltipclose${key}`}
              >
                {t("Close")}
              </UncontrolledTooltip>
              <UncontrolledTooltip
                className="tooltip-actions"
                placement="auto"
                target={`tooltipspy${key}`}
              >
                {t("Spy")}
              </UncontrolledTooltip>
            </div>
          ),
          status: renderConversationStatus(item),
          consumer_name: (
            <div
              onClick={(e) => {
                navigator.clipboard.writeText(item.consumer_name);
                setTooltipCopy({
                  target: `tooltipname${key}`,
                  message: `${t("Name")} ${t("Copied to keyboard!")}`,
                });
              }}
            >
              <p
                id={`tooltipname${key}`}
                className={`${
                  item.consumer_display_name ? "" : "text-muted"
                } pointer`}
              >
                {iconsObject[item?.channel_name] && (
                  <i
                    id={`tooltipiconschannel${key}`}
                    className={`mdi mdi-${
                      iconsObject[item?.channel_name].icon
                    } text-muted mr-1`}
                  ></i>
                )}
                {item.consumer_display_name
                  ? item.consumer_display_name
                  : item.consumer_name
                  ? item.consumer_name
                  : "-"}
              </p>
              {item.consumer_display_name && (
                <UncontrolledTooltip
                  className="tooltip-actions"
                  placement="auto"
                  target={`tooltipname${key}`}
                >
                  {item.consumer_name}
                </UncontrolledTooltip>
              )}
              {tooltipCopy && (
                <Tooltip
                  placement="auto"
                  isOpen={tooltipCopy}
                  target={tooltipCopy.target}
                >
                  {tooltipCopy.message}
                </Tooltip>
              )}
              {iconsObject[item?.channel_name] && (
                <UncontrolledTooltip
                  className="tooltip-actions"
                  placement="auto"
                  target={`tooltipiconschannel${key}`}
                >
                  {t(iconsObject[item?.channel_name].name)}
                </UncontrolledTooltip>
              )}
            </div>
          ),
          user_name: (
            <>
              <p className="text-muted">
                {item.transf_user_id && (
                  <i className={`mdi mdi-share font-size-14 mr-1`} />
                )}

                {item.extra_info?.isAgents
                  ? "AI Agents"
                  : item.user_name
                  ? item.user_name
                  : "-"}

                {item.user_has_not_skill && (
                  <i
                    id={`tooltip-user-not-skill-${key}`}
                    className={`mdi mdi-alert-circle font-size-14 ml-1`}
                  />
                )}
                {item.user_has_not_signalr && (
                  <i
                    id={`tooltip-user-not-signalr-${key}`}
                    className={`mdi mdi-alert-circle font-size-14 ml-1`}
                  />
                )}
                {item.extra_info?.isAgents && (
                  <img
                    src={agentInfo.icon}
                    alt={agentInfo.alt}
                    width={15}
                    height={15}
                    className="ml-1"
                  />
                )}
              </p>
              {item.user_has_not_skill && (
                <UncontrolledTooltip
                  className="tooltip-actions"
                  placement="auto"
                  target={`tooltip-user-not-skill-${key}`}
                >
                  {t("This agent its not assigned to this skill")}
                </UncontrolledTooltip>
              )}
              {item.user_has_not_signalr && (
                <UncontrolledTooltip
                  className="tooltip-actions"
                  placement="auto"
                  target={`tooltip-user-not-signalr-${key}`}
                >
                  {t("This agent its not online")}
                </UncontrolledTooltip>
              )}
            </>
          ),
          skill_name: (
            <p className="text-muted">
              {item.skill_name ? item.skill_name : "-"}
            </p>
          ),
          group: (
            <p className="text-muted">
              {item.group ?? "-"} {item.group_deleted_at ? t("(Deleted)") : ""}{" "}
            </p>
          ),
          queue_time: (
            <>
              {item.queue_time
                ? DateTime.fromJSDate(new Date(item.queue_time)).toFormat(
                    "dd/MM/yyyy HH:mm"
                  )
                : "-"}
            </>
          ),
          created_at: (
            <div>
              <p id={`tooltip-time-${key}`} className="text-muted text-center">
                {item.created_at
                  ? DateTime.fromJSDate(new Date(item.created_at)).toFormat(
                      "dd/MM/yyyy HH:mm"
                    )
                  : "-"}
              </p>
              {item.initial_conversation_time && (
                <UncontrolledTooltip
                  className="tooltip-actions"
                  placement="auto"
                  target={`tooltip-time-${key}`}
                >
                  {t("Conversation started at") +
                    " " +
                    DateTime.fromJSDate(
                      new Date(item.initial_conversation_time)
                    ).toFormat("dd/MM/yyyy HH:mm")}
                </UncontrolledTooltip>
              )}
            </div>
          ),
          end_conversation_time: (
            <p className="text-muted text-center">
              {item.end_conversation_time
                ? DateTime.fromJSDate(
                    new Date(item.end_conversation_time)
                  ).toFormat("dd/MM/yyyy HH:mm")
                : "-"}
            </p>
          ),
          ta: (
            <p className="text-muted text-center">
              {item?.time_agent && item?.user_name
                ? Duration.fromObject({
                    seconds: Math.abs(item.time_agent),
                  }).toFormat(
                    Math.abs(item.time_agent) < 60
                      ? "ss's'"
                      : Math.abs(item.time_agent) < 3600
                      ? "mm'm' ss's'"
                      : "hh'h' mm'm'"
                  )
                : "-"}
            </p>
          ),
          duration: (
            <p className="text-muted text-center">
              {item.duration
                ? Duration.fromObject({
                    seconds: item.duration,
                  }).toFormat(
                    item.duration < 60
                      ? "ss's'"
                      : item.duration < 3600
                      ? "mm'm' ss's'"
                      : "hh'h' mm'm'"
                  )
                : "-"}
            </p>
          ),
          last_message_time: (
            <p className="text-muted text-center">
              {item.last_message_time
                ? DateTime.fromJSDate(
                    new Date(item.last_message_time)
                  ).toFormat("dd/MM/yyyy HH:mm")
                : "-"}
            </p>
          ),
          last_msg_consumer: (
            <p className="text-muted text-center">
              {item.last_msg_consumer
                ? Duration.fromObject({
                    seconds: item.last_msg_consumer,
                  }).toFormat(
                    item.last_msg_consumer < 60
                      ? "ss's'"
                      : item.last_msg_consumer < 3600
                      ? "mm'm' ss's'"
                      : "hh'h' mm'm'"
                  )
                : "-"}
            </p>
          ),
          csat: (
            <p className="text-muted text-center">
              {item?.csat
                ? (parseFloat(item?.csat / item?.max_csat) * 100).toFixed(2) +
                  "%"
                : "-"}
            </p>
          ),
        }))
      : [];

  return (
    <>
      <ConversationList
        qtdDefault={props?.qtdDefault}
        tableData={payload}
        loadingData={loadingData}
        lengthData={payloadData?.length}
        conversationsCheckedArray={conversationsCheckedArray}
        setConversationsCheckedArray={setConversationsCheckedArray}
        orderBy={orderBy}
        handleSort={handleSort}
      />
    </>
  );
};

export default withTranslation()(ConversationTableBody);
